// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"xLEaimc","header":"Zb-NiHG","footer":"_2-UJgpr","body":"_4dx9Nn7","hasFooter":"_2qIvGBj","close":"_3rZlkmo","link":"yFABGnh","container":"_2nFo01D","outerWrapper":"_1__Ug8F","wrapper__open":"_1NIO-n7","innerWrapper":"_2jIx_En","slidedown":"_2Ydfmv-","wrapper__hidden":"_3YiroC7"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Dropdown/index.css
// module id = ./template/components/Dropdown/index.css
// module chunks = client.sitechrome